import {http, onSuccess, onFail} from '../player/http';

export const getWidgetPlayerSettingsList = (eventKey) => {
    return http.get(`/api/cp/event/${eventKey}/module/widget/player`)
        .then(onSuccess, onFail);
};

export const getWidgetPlayerSettings = (widgetKey) => {
    return http.get(`/api/cp/event/module/widget/player/${widgetKey}`)
        .then(onSuccess, onFail);
};

export const createWidgetPlayer = (eventKey, params = {}) => {
    return http.post(`/api/cp/event/${eventKey}/module/widget/player`, params)
        .then(onSuccess, onFail);
};

export const updateWidgetPlayer = (widgetKey, payload) => {
    return http.post(`/api/cp/event/module/widget/player/${widgetKey}`, payload)
        .then(onSuccess, onFail);
};

export const deleteWidgetPlayer = (widgetKey) => {
    return http.delete(`/api/cp/event/module/widget/player/${widgetKey}`)
        .then(onSuccess, onFail);
};
